import { faUser } from "@fortawesome/pro-solid-svg-icons"
import { Grid, ListItem, ListItemAvatar, ListItemText, Typography, useTheme } from "@mui/material"
import { styled } from "@mui/material/styles"
import PaperBox from "components/PaperBox"
import { CircleIcon } from "components/icons/CircleIcon"

const StyledListItem = styled(ListItem)({
  padding: "0"
})

const StyledGreyText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[500]
}))

const StyledBlackText = styled(Typography)(({ theme }) => ({
  color: theme.palette.foreground.default,
  fontWeight: "500"
}))

export const VehicleAlarmDashboardCard = ({ title, icon, itemLength, vehicleAlarmsResult }) => {
  const theme = useTheme()
  return (
    <Grid item xs={12} md={4} lg={3} xl={2}>
      <PaperBox paddingX={3} paddingY={3} marginY={0}>
        <StyledListItem disableGutters>
          <ListItemAvatar>
            <CircleIcon
              icon={icon ? icon : faUser}
              backgroundColor={theme.palette.primary[300]}
              color={theme.palette.primary[900]}
              size="lg"
              sx={{ marginRight: "15px" }}
            />
          </ListItemAvatar>
          <ListItemText>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item>
                <StyledGreyText color="secondary" variant="bodyMedium">
                  {title}
                </StyledGreyText>
                <StyledBlackText variant="h1">{itemLength(title)}</StyledBlackText>
              </Grid>
            </Grid>
          </ListItemText>
        </StyledListItem>
      </PaperBox>
    </Grid>
  )
}
